import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_ENTITY_STATUS = 'SET_ENTITY_STATUS';
export const RESET_ENTITY_STATUS = 'RESET_ENTITY_STATUS';

export const setEntityStatus = makeActionCreator(SET_ENTITY_STATUS);
export const resetEntityStatus = makeActionCreator(RESET_ENTITY_STATUS);
